import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import border from "../com/border";
import aMap from "../com/map";
import maintenanceTrend from "../com/maintenanceTrend";
import workOrder from "../com/workOrder";
import IwsVideo from '@comp/VideoPlay/IwsVideo';
import { queryLiveVideo } from '@/api/api';
export default {
  name: 'atmosphere',
  components: {
    maintenanceTrend: maintenanceTrend,
    border: border,
    aMap: aMap,
    workOrder: workOrder,
    IwsVideo: IwsVideo
  },
  data: function data() {
    return {
      showMaintenance: false,
      peopleList: [],
      width: 0,
      height: 0,
      leftVideoList: [],
      rightVideoList: []
    };
  },
  computed: {
    classOption: function classOption() {
      return {
        step: .5,
        // 数值越大速度滚动越快
        limitMoveNum: 4,
        // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true,
        // 是否开启鼠标悬停stop
        direction: 1,
        // 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0,
        // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0,
        // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)

      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.width = document.querySelector('.video-box').clientWidth;
    this.height = document.querySelector('.video-box').clientWidth * 0.9;
    window.addEventListener('resize', function () {
      _this.width = document.querySelector('.video-box').clientWidth;
      _this.height = document.querySelector('.video-box').clientWidth * 0.9;
    });
    this.getVideoList();
  },
  methods: {
    getVideoList: function getVideoList() {
      var _this2 = this;

      queryLiveVideo({
        size: -1
      }).then(function (res) {
        console.log('res', res);

        if (res.success && res.result.records) {
          res.result.records.forEach(function (item, index) {
            if (index % 2 == 0) {
              _this2.leftVideoList.push(item);
            } else {
              _this2.rightVideoList.push(item);
            }
          });
        }
      });
    },
    filterNum: function filterNum(num) {
      return num >= 10 ? num : '0' + num;
    }
  }
};